export const TimeDifference = (hsTime) => {
  if (hsTime == null) {
    return 10000;
  }
  var startTime = new Date(); //结束时间
  var mss = startTime.getTime() - new Date(hsTime.replace(/-/g, "/")).getTime(); //时间差的毫秒数

  let days = Math.floor(mss / (24 * 3600 * 1000));
  var hours =
    parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + days * 24;

  return hours;
};

export const DetectionHsTimeout = (hsTime) => {
  if (24 > hsTime && hsTime > 0) {
    return "24H";
  } else if (48 > hsTime && hsTime > 24) {
    return "48H";
  } else if (72 > hsTime && hsTime > 48) {
    return "72H";
  } else {
    return "大于72H";
  }
};

export const getUrlCode = () => {
  // 截取url中的code方法
  var url = location.search;
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
    }
  }
  return theRequest;
};

/** 图片转base64 */
export const imageUrlToBase64 = (url) => {
  return fetch(url)
    .then(response => response.blob())
    .then(blob => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsDataURL(blob);
      });
    });
}


export const generateInviteCode = (id) => {
  let encodedId = btoa(id.toString());
  let randomPart = Math.random().toString(36).substring(2, 8);
  return encodedId + randomPart;
}


export const parseInviteCode = (inviteCode) => {
  let encodedId = inviteCode.slice(0, -6);
  let decodedId = atob(encodedId);
  return parseInt(decodedId);
}